import { render, staticRenderFns } from "./EditRedeemCodeGiftDialog.vue?vue&type=template&id=06ed5f8e"
import script from "./EditRedeemCodeGiftDialog.vue?vue&type=script&lang=js"
export * from "./EditRedeemCodeGiftDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports